import { createRoutine } from "redux-saga-routines";

export const hospitalRoutine = createRoutine("API_HOSPITAL_GET");
